import React from "react";
import { useTranslation } from "react-i18next";
import {
    DetailsBlock,
    DetailsHeader,
    DetailsRow,
    Label,
    Value,
} from "src/components/ContinueDealerOffer/Pages/ReviewPage";
import { localizeCurrencyWithDecimals } from "src/utils";
import { DealerOfferListItem } from "Types/api/DealerOfferListItem";

interface Props {
    accessories: DealerOfferListItem[];
}

const Accessories = ({ accessories }: Props) => {
    const { t } = useTranslation();

    if (accessories.length === 0) {
        return null;
    }

    return (
        <DetailsBlock>
            <DetailsHeader>{t("DealerOffer.ContinueDealerOffer.ReviewPage.Accessories.Header")}</DetailsHeader>

            {accessories.map(({ name, value }, index) => (
                <DetailsRow key={index}>
                    <Label>{name}</Label>
                    <Value>{localizeCurrencyWithDecimals(value)}</Value>
                </DetailsRow>
            ))}
        </DetailsBlock>
    );
};

export default Accessories;
